/* eslint-disable no-useless-escape */
import Vue from "vue";
import {extend, ValidationProvider} from "vee-validate";
import {regex} from "vee-validate/dist/rules";

const discoverRegex =
  /^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])\d{12}$/;

const emailRegex =
  /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
const cvvRegex = /^[0-9]{3,4}$/;

extend("requiredBoolean", {
  validate(value) {
    return {
      required: true,
      valid: value !== "",
    };
  },
  message: "Field is required",
  computesRequired: true,
});
extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined, []].indexOf(value) === -1,
    };
  },
  message: "Field is required",
  computesRequired: true,
});
extend("email", {
  validate(value) {
    return {
      required: true,
      valid: emailRegex.test(value),
    };
  },
  message: "E-mail must be valid",
  computesRequired: true,
});
extend("phone", {
  validate(value) {
    return {
      required: true,
      valid: value && value.length == 14,
    };
  },
  message: "Please enter a valid US Phone number",
  computesRequired: true,
});
extend("cc", {
  validate(value) {
    var valid = require("card-validator");
    return {
      required: true,
      valid: value && valid.number(value).isValid,
    };
  },
  message: "Please enter a valid card number",
  computesRequired: true,
});
extend("ssn", {
  validate(value) {
    return {
      required: true,
      valid: value && value.length == 11,
    };
  },
  message: "Please enter a valid SSN number",
  computesRequired: true,
});
extend("zip", {
  validate(value) {
    return {
      required: true,
      valid: value && value.length == 5,
    };
  },
  message: "Please enter a valid zip code",
  computesRequired: true,
});
// Two-letter USPS code of a state, DC or a territory.
const US_STATES = (
  "AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ " +
  "NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY DC PR GU VI AS MP"
).split(" ");
extend("usState", {
  validate: (value) => US_STATES.includes(String(value || "").toUpperCase()),
  message: "{_field_} must be a valid US state code",
});
// M/YYYY (or MM/YYYY) not later than the current month.
extend("notFutureMonth", {
  validate(value) {
    const match = /^(\d{1,2})\/(\d{4})$/.exec(value || "");
    if (!match) return true;
    const now = new Date();
    const month = Number(match[2]) * 12 + Number(match[1]);
    return month <= now.getFullYear() * 12 + now.getMonth() + 1;
  },
  message: "{_field_} can't be in the future",
});
extend("cvv", {
  validate(value) {
    return {
      required: true,
      valid: cvvRegex.test(value),
    };
  },
  message: "Please enter a valid cvv",
  computesRequired: true,
});
extend("commission_rate", {
  validate(v) {
    return {
      required: true,
      valid: v <= 100 && v >= 0,
    };
  },
  message: "Percentage should be between 0 to 100",
  computesRequired: true,
});
extend("commission", {
  validate(v) {
    const str = String(v).trim();
    const isPercent = str.endsWith("%");
    const num = parseFloat(isPercent ? str.slice(0, -1) : str);
    if (isNaN(num) || num < 0) return { required: true, valid: false };
    if (isPercent) {
      return { required: true, valid: num >= 0 && num <= 100 };
    }
    return { required: true, valid: num >= 0 && num <= 100 };
  },
  message: "Enter a value between 0-100 (e.g. 30 or 30%) or 0-1 (e.g. 0.3)",
  computesRequired: true,
});

extend("restrictDiscover", {
  validate(v) {
    return {
      required: true,
      valid: v && !discoverRegex.test(v.split(" ").join("")),
    };
  },
  message: "Card type can't be Discover",
  computesRequired: true,
});
extend("decimal", {
  validate(value) {
    return /^-?\d+(\.\d+)?$/.test(value);
  },
  message: "Only numeric values are allowed",
  computesRequired: true,
});
extend("password", {
  validate(v) {
    return {
      required: true,
      valid: v && v.length >= 8,
    };
  },
  message: "Password must be at least 8 characters long",
  computesRequired: true,
});

extend("passwordConfirm", {
  params: ["target"],
  validate(value, { target }) {
    return {
      required: true,
      valid: value === target,
    };
  },
  message: "Passwords do not match",
  computesRequired: true,
});

extend("regex", {...regex, message: "{_field_} has wrong format"});

Vue.component("ValidationProvider", ValidationProvider);
